import { v4 as uuid } from 'uuid';
import { RootGizmo } from '../../../gizmos';
import { IFilledFormV2, IRootGizmoData, IUserV2 } from '../../../types';
import { gnov } from '../../../utils';
import {
  rootGizmoDataV2ToV3,
  rootGizmoDataV3ToV2,
} from '../../../gizmos/utils';
import { FlowyFoundation } from '../../../flowy';
import axios from 'axios';

interface IParams {
  rootGizmo: RootGizmo;
  context: {
    apiUrl: string;
    user?: IUserV2;
    foundation?: FlowyFoundation;
  };
}

/**
 * When a successful signup has happened we're going to call this function. When configured
 * it will automatically login the user after a successful signup.
 *
 * @param {RootGizmo} rootGizmo RootGizmo instance used to signup
 */
async function formAuthSignIn({ rootGizmo, context }: IParams) {
  const { apiUrl, user, foundation } = context;
  const config = rootGizmo.getConfig();
  const data = rootGizmo.getData();

  if (
    config.ops?.form?.auth?.loginAfterSignup === true &&
    config.ops?.form?.auth?.usernameGizmoUid &&
    data?.d
  ) {
    const usernameFid = rootGizmo.getInfoCB({
      type: 'uidToFid',
      uid: config.ops.form.auth.usernameGizmoUid,
    });

    const username = gnov(data.d, `${usernameFid}.v`);
    const password = gnov(data.d, 'added_password.v');

    if (username && password) {
      const fid = uuid();

      const loginRootGizmoData: IRootGizmoData = {
        formId: 'login-form-fid',
        source: 'web',
        fid,
        filledFormId: fid,
        rootGizmoFid: 'login-form-fid',
        rootGizmoVersion: 8,
        version: 11,
        d: {
          [usernameFid]: { v: username },
          added_password: { v: password },
        },
      };
      const loginFilledForm = rootGizmoDataV3ToV2({
        data: loginRootGizmoData,
      });
      let headers = {};
      const url = `${apiUrl}/main_api/v1/form_auth/sign_in/${config.fid}`;

      if (user?.credentials) {
        const credentials: any = user.credentials;

        headers = { ...credentials };
      }

      try {
        const response = await axios.post(
          url,
          { registers: [loginFilledForm] },
          { headers }
        );

        if (response.status === 200) {
          const { data } = response;
          const userToSet: IUserV2 = {
            username: response.headers.uid,
            id: 'form-auth-user',
            credentials: {
              'access-token': response.headers['access-token'],
              client: response.headers.client,
              'token-type': response.headers['token-type'],
              uid: response.headers.uid,
              expiry: response.headers.expiry,
              'auth-form-fid': response.headers['auth-form-fid'],
            },
          };

          if (data.data) {
            userToSet.id = data.fid;
            // We're creating this in order to be able to use the function to transform
            const dummyFilledform: IFilledFormV2 = {
              id: '63f3037295b17d2ea608347d',
              formId: '63e02a328e1e8300b2bb200e',
              formVersion: 8,
              fid:
                '63e02a328e1e8300b2bb200e_63e028098e1e8300b2bb200c_1676869259',
              filledFormId:
                '63e02a328e1e8300b2bb200e_63e028098e1e8300b2bb200c_1676869259',
              answers: data.data,
              source: 'mobile',
              version: 1,
              username: 'axe',
              epoch_start: 1676869259,
              epoch_end: 1676870508,
              status: 's1',
            };
            const v3FilledForm = rootGizmoDataV2ToV3({
              data: dummyFilledform,
            });

            userToSet.variables = v3FilledForm.d;
          }
          if (data.gizmos) {
            // TODO: transform from v2 to v3
            userToSet.gizmos = data.gizmos;
          }

          await foundation?.getPlatformInterface()?.setUser(userToSet);
          await foundation?.getGlobal()?.sendNotification({
            notification: {
              fid: 'n0',
              type: 'success',
              label: 'Ingreso exitoso',
            },
          });
          await foundation?.getPlatformCallbacks()?.platformOperationCB({
            operation: 'navigation.link',
            params: {
              path: '/',
            },
          });
        }
      } catch (e) {
        console.log('---------login.error: ', e);
      }
    }
  }
}

export default formAuthSignIn;
